<script setup>
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

/**
 * Get optimized image URL
 * Prefers _optimized.webp version if available, falls back to original
 */
function getImageUrl(imageUrl) {
    if (!imageUrl) return ''

    // If it's already a full URL, return as-is
    if (imageUrl.startsWith('http')) {
        return imageUrl
    }

    // Use optimized version if available (created by projects:optimize-content-images command)
    // The command creates files with _optimized.webp suffix
    return '/storage/' + imageUrl
}
</script>

<template>
    <div class="mx-auto w-90 overflow-hidden rounded-3xl lg:w-full lg:max-w-lg">
        <Swiper
            :modules="[Navigation, Pagination]"
            navigation
            pagination
            loop
            :watchSlidesProgress="true"
            :slidesPerView="1"
            :spaceBetween="20"
            class="swiper-equal-height"
        >
            <SwiperSlide
                v-for="(image, index) in props.content.images"
                :key="index"
                class="flex min-h-[400] items-center justify-center selection:bg-transparent xl:min-h-[600px]"
            >
                <img
                    class="max-h-full max-w-full rounded-3xl object-contain"
                    :src="getImageUrl(image.url)"
                    :alt="`Obrázek sádrokartony a izolace - ${index + 1}`"
                    loading="lazy"
                    :fetchpriority="index === 0 ? 'high' : 'auto'"
                />
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<style scoped>
.swiper-equal-height .swiper-slide {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
